/* eslint-disable no-console */
import Vue from 'vue'
import Vuex from 'vuex'

const fb = require('../firebaseConfig');

Vue.use(Vuex);

// handle page reload
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('SET_CURRENT_USER', user);
        store.dispatch('fetchUserProfile');
    }
});

const store = new Vuex.Store({
    state: {
        currentUser: null,
        userProfile: {},
        csCountries: [],
        csData: {}
    },
    getters: {
        getCsCountries: state => {
            return state.csCountries;
        },
        getCsData: state => {
            return state.csData;
        }

    },
    mutations: {
        SET_CURRENT_USER(state, val) {
            state.currentUser = val;
        },
        SET_USER_PROFILE(state, val) {
            state.userProfile = val;
            //i18n.locale = val.lng;
        },
        //TODO Change name to Upper Case
        updateCsCountries: (state, payload) => {
            state.csCountries = payload;
        },
        updateCsData: (state, payload) => {
            state.csData = payload;
        },
    },
    actions: {
        fetchUserAccount({ state }) {
            return fb.db.collection('users')
                .doc(state.currentUser.uid)
                .get();

        },
        fetchHistory({ state }) {
            const userId = state.currentUser.uid;
            return fb.db.collection('/allGeneratedCs/' + userId + '/cs').orderBy("createdOn", "desc").get();
        },
        fetchOrdersHistory({ state }) {
            const userId = state.currentUser.uid;
            return fb.db.collection('/users/' + userId + '/ordersHistory').orderBy("orderedOn", "desc").get();
        },
        fetchUserProfile({ commit, state }) {
            fb.db.collection('users')
                .doc(state.currentUser.uid)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        const userProfileObj = Object.assign(doc.data(), {
                            userId: doc.id
                        });
                        commit('SET_USER_PROFILE', userProfileObj);
                    } else {
                        //TODO: treat error

                    }
                })
        }
    }
});

export default store;
